/////////////////////////////////////////////////////
// Add your custom code here.
// This file and any changes you make to it are preserved every time the app is generated.
/////////////////////////////////////////////////////
import { NgModule } from '@angular/core';

import { TimeoutManagerService } from '../../../shared/services/timeout-manager.service';
import { AppLayoutViewBaseComponent } from './app-layout.view.base.component';
import { AppLayoutViewComponent } from './app-layout.view.component';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SharedModule } from './../../../shared/shared.module';
import { RouterModule } from '@angular/router';


const config: NgModule = {
    declarations: [AppLayoutViewBaseComponent, AppLayoutViewComponent],
    entryComponents: [],
    exports: [AppLayoutViewComponent],
    imports: [CommonModule, SharedModule, LayoutModule, RouterModule],
    providers: [TimeoutManagerService],
}

@NgModule(config)
export class AppLayoutViewModule {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/modules/application/app-layout/app-layout.view.module.ts